// react
import React from "react"
import { connect } from "react-redux"
// material-ui
import { Card, CardActions, CardHeader, CardText } from "material-ui/Card"
import Checkbox from "material-ui/Checkbox"
import Chip from "material-ui/Chip"
import Divider from "material-ui/Divider"
// app
import Edit from "components/common/buttons/Edit"
import SaveCancel from "components/common/buttons/SaveCancel"
import TextField from "components/common/TextField"
import OptionGroup from "containers/OptionGroup"

import { getPerson, putPerson } from "actions/profile/person/actions.js"

import * as types from "components/person/types"


class Step8 extends React.Component {
    constructor(props) {
        super()

        this.state = { edit: false }

        this.edit = () => this.setState({ edit: true })
        this.cancel = () => this.setState({ edit: false })
        
        this.save = this.save.bind(this)

        this.onHoursChange = (hours) => this.setState({ hours })
        this.onPICHoursChange = (pichours) => this.setState({ pichours })
        this.onJobStatusChange = (jobstatus) => this.setState({ jobstatus })
        this.onFreelanceCheck = (e, freelance) => this.setState({ freelance: freelance ? 1:0 })
        this.onPermanentCheck = (e, permanent) => this.setState({ permanent: permanent ? 1:0 })
        this.onNotLookingCheck = (e, notlooking) => this.setState({ notlooking: notlooking ? 1:0 })
        this.onSchoolChange = (school) => this.setState({ school })
        this.onCompanyChange = (company) => this.setState({ company })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.person) {
            this.setState({
                freelance: nextProps.person.get("freelance", 0),
                permanent: nextProps.person.get("permanent", 0),
                notlooking: nextProps.person.get("notlooking", 0)
            })
        }
    }

    componentDidMount() {
        const personid = this.props.personid

        this.props.getPerson(personid)
    }

    save() {
        const { jobstatus, freelance, permanent, notlooking, school, company, hours, pichours } = this.state

        this.props.putPerson({
            id: this.props.personid,
            jobstatus, freelance, permanent, notlooking, school, company, hours, pichours
        })

        this.setState({ edit: false })
    }

    renderEdit() {
        const { person } = this.props

        return (
            <CardText>
                <TextField
                    label="Total Flight Hours"
                    onChange={ this.onHoursChange }
                    value={ person.get("hours") }
                    type="number"
                />
                <TextField
                    label="PIC Hours"
                    onChange={ this.onPICHoursChange }
                    value={ person.get("pichours") }
                    type="number"
                />
                <div style={{ margin: "16px 0" }}>
                    <h5>Job Status</h5>
                    <OptionGroup
                        table="jobstatus"
                        value={ person.get("jobstatus") }
                        onChange={ this.onJobStatusChange }
                    />
                </div>
                <div style={{ marginTop: 16 }}>
                    <h5>Looking For</h5>
                    <Checkbox
                        label="Freelance Contracts"
                        checked={ this.state.freelance === 1 }
                        onCheck={ this.onFreelanceCheck }
                    />
                    <Checkbox
                        label="Permanent Contracts"
                        checked={ this.state.permanent === 1}
                        onCheck={ this.onPermanentCheck }
                    />
                    <Checkbox
                        label="Currently Not Looking"
                        checked={ this.state.notlooking === 1}
                        onCheck={ this.onNotLookingCheck }
                    />
                </div>
                { this.props.type !== types.FLIGHT_ATTENDANT ?
                    <div>
                        <TextField
                            label="Flight School"
                            hintText="Your former or current flight school"
                            onChange={ this.onSchoolChange }
                            value={ person.get("school") }
                        />
                        <br />
                    </div>
                    : null
                }
                <TextField
                    label="Company"
                    hintText="The company you are currently working for"
                    onChange={ this.onCompanyChange }
                    value={ person.get("company") }
                />
            </CardText>
        )
    }

    renderView() {
        const { person } = this.props
        const chipStyle = {
            margin: 5
        }

        return (
            <CardText>
                <div style={{ marginBottom: 16 }}>
                    <Chip style={ chipStyle }><b>{ person.get("hours") }</b> Total Flight Hours</Chip>
                    <Chip style={ chipStyle }><b>{ person.get("pichours") }</b> PIC Hours</Chip>
                    <Chip style={ chipStyle }>{ person.get("jobstatus") }</Chip>
                </div>
                <Divider />
                <h5>Looking For</h5>
                <div style={{ marginBottom: 16 }}>
                    { person.get("freelance") === 1 ?
                        <Chip style={ chipStyle }>Freelance Contracts</Chip>
                        : null
                    }
                    { person.get("permanent") === 1 ?
                        <Chip style={ chipStyle }>Permanent Contracts</Chip>
                        : null
                    }
                    { person.get("notlooking") === 1 ?
                        <Chip style={ chipStyle }>Currently Not Looking</Chip>
                        : null
                    }
                </div>
                <Divider />
                { this.props.type !== types.FLIGHT_ATTENDANT ?
                    <div>
                        <h5>Flight School</h5>
                        <p>{ person.get("school", "n/a") === null ? "n/a" : person.get("school") }</p>
                    </div>
                    : null 
                }
                <Divider />
                <h5>Company</h5>
                <p>{ person.get("company", "n/a") === null ? "n/a" : person.get("company") }</p>
            </CardText>
        )
    }

    render() {
        return (
            <Card className="card">
                <CardHeader
                    title="Overview"
                    style={{ paddingBottom: 0 }}
                />
                { this.state.edit ?
                    this.renderEdit()
                    :
                    this.renderView()
                }
                <CardActions>
                    { this.state.edit ?
                        <SaveCancel
                            onSave={ this.save }
                            onCancel={ this.cancel }
                        />
                        :
                        <Edit onEdit={ this.edit } />
                    }
                </CardActions>
            </Card>
        )
    }
}

const mapStateToProps = state => {
    return {
        person: state.profile.person.get("data"),
        type: state.profile.person.get("data").get("type", "Pilot")
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getPerson: id => dispatch(getPerson(id)),
        putPerson: person => dispatch(putPerson(person))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Step8)


/** WEBPACK FOOTER **
 ** ./src/containers/Profile/Step8.js
 **/